/* Apply a promotional coupon only to a qualified referral visitor. */
(() => {
  const root=window.Shopify?.routes?.root || '/';
  let pending,initialized=false;
  const jsonResponse=r=>{if(!r.ok)throw Error('cart');return r.json()};
  async function apply(code) {
    if(pending)return pending;
    pending=(async()=>{
      const before=await fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(jsonResponse);
      const codes=(before.discount_codes||[]).filter(c=>c.applicable).map(c=>c.code);
      if(codes.some(c=>c.toLowerCase()===code.toLowerCase()))return {before,after:before};
      const after=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:[...codes,code].join(',')})}).then(jsonResponse);
      return {before,after};
    })().finally(()=>{pending=null});
    return pending;
  }
  function enable(){
    const code=window.HTSDetectReferral?.();
    if(!code||initialized)return false;
    initialized=true;
    const forms=()=>document.querySelectorAll('form[action*="/cart"]').forEach(form=>{
      let input=form.querySelector('input[name="discount"]');
      if(!input){input=document.createElement('input');input.type='hidden';input.name='discount';form.append(input);}
      input.value=code;
    });
    forms();
    document.addEventListener('submit',event=>{
      if(event.submitter?.name!=='checkout'||event.target.dataset.htsReady)return;
      event.preventDefault();const form=event.target,button=event.submitter;
      forms();apply(code).catch(()=>{}).finally(()=>{form.dataset.htsReady='1';form.requestSubmit(button);delete form.dataset.htsReady;});
    },true);
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[href*="/checkout"]');if(!link)return;
      const url=new URL(link.href,location.href);if(url.origin===location.origin){url.searchParams.set('discount',code);link.href=url.href;}
    },true);
    apply(code).then(({before,after})=>{if(/\/cart\/?$/.test(location.pathname)&&before.total_price!==after.total_price)location.reload()}).catch(()=>{});
    return true;
  }
  if(!enable()){
    // A referral app can write its actual discount cookie after DOM ready.
    let checks=0;
    const timer=setInterval(()=>{if(enable()||++checks>=20)clearInterval(timer)},250);
    // Clean only the default code accidentally auto-added by v1.7.0, and only
    // when no referral/coupon signal exists. Other customer codes stay intact.
    setTimeout(async()=>{
      if(initialized||window.HTSDetectReferral?.())return;
      try {
        const before=await fetch(root+'cart.js').then(jsonResponse);
        const defaultCode=window.HTSPublicOffer?.code;
        const codes=(before.discount_codes||[]).filter(c=>c.applicable).map(c=>c.code);
        if(!codes.some(c=>c.toLowerCase()===defaultCode?.toLowerCase()))return;
        const keep=codes.filter(c=>c.toLowerCase()!==defaultCode.toLowerCase());
        const after=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:keep.join(',')})}).then(jsonResponse);
        if(/\/cart\/?$/.test(location.pathname)&&before.total_price!==after.total_price)location.reload();
      } catch(_){}
    },5500);
  }
})();
